import fileSys from "../../fileoprators/fileSystem";
import { isDefined, isFunction } from "../../shared/utils";
import { HTTP_ERRORS } from "./const";
const request = window.require("request");
const fs = window.require("fs");

let clientpfx = fs.readFileSync(fileSys.getCfgPath("../keys/client.pfx"));

export let _config = {
  // serverip: window.__main__.debug ? '192.168.1.119' : '127.0.0.1',
  serverip: window.__main__.debug ? "127.0.0.1" : "127.0.0.1",
  serverport: 8080,
  sslport: 4430,
  serverssl: 0
};
export const reqGet = (url, callback) => {
  request({ url, timeout: 1000 * 3 }, (error, response, body) => {
    if (!isDefined(error) && isDefined(response) && response.statusCode === 200) {
      callback(null, body);
    } else {
      callback(new Error("failed"));
    }
  });
};
export const reqGetPip = (url, filepath, callback) => {
  let out = fs.createWriteStream(filepath);
  try {
    return request
      .get(url, { timeout: 5 * 1000 })
      .on("response", (data) => {})
      .on("end", () => {
        if (callback) callback();
      })
      .on("error", (err) => {
        console.log("error:", err);
        callback(err);
      })
      .pipe(out);
  } catch (e) {
    if (isFunction(callback)) {
      callback(new Error("request error"));
    }
  }
};
const _mergeOptions = (req) => {
  let body = req["body"];
  let method = isDefined(req["body"]) ? "POST" : "GET";
  let cmd = req["cmd"] || "";
  let headers = isDefined(req["token"])
    ? {
        "cache-control": "no-cache",
        "content-type": "application/json",
        "x-access-token": req["token"]
      }
    : {
        "cache-control": "no-cache",
        "content-type": "application/json"
      };
  let options = {
    method: method,
    url: `http://${_config.serverip}:${_config.serverport}/${cmd}`,
    headers: headers,
    body: body,
    user: window.session ? window.session.user : undefined,
    json: true,
    timeout: 5000
  };
  if (_config.serverssl === 1) {
    options.url = `https://${_config.serverip}:${_config.sslport}/${cmd}`;
    options.pfx = clientpfx;
    // options.cert = clientpfx
    options.passphrase = "mw.com";
    options.rejectUnauthorized = false;
  }
  return options;
};

function httpRequest(req, callback) {
  let result = {
    message: "failed"
  };
  let reqonce = request(_mergeOptions(req), function (error, response, body) {
    if (isDefined(error)) {
      result.error = error;
      if (isFunction(callback)) callback(result);
    } else if (isDefined(response) && response.statusCode !== 200) {
      const { statusCode } = response;

      if (statusCode === 400) {
        result.error = { code: HTTP_ERRORS.serverError };
      } else if (statusCode === 401) {
        if (isDefined(body.error)) {
          if (body.error.indexOf("username or password error") >= 0) {
            result.error = {
              code: HTTP_ERRORS.errorUserOrPassword
            };
          } else if (body.error.indexOf("token error") >= 0) {
            result.error = {
              code: HTTP_ERRORS.tokenError
            };
          }
        } else {
          result.error = {
            code: HTTP_ERRORS.netError
          };
        }
      } else if (statusCode === 404) {
        result.error = {
          code: HTTP_ERRORS.notFound
        };
      }
      if (isFunction(callback)) callback(result);
    } else if (!isDefined(body)) {
      if (isFunction(callback)) callback(result);
    } else {
      if (isFunction(callback)) callback(body);
    }
    reqonce = null;
  });
}
export const setServerConfig = (config) => {
  _config = { ..._config, ...config };
};
export const getMediaFileUrl = (filename) => {
  let protocol = _config.serverssl === 1 ? "https" : "http";
  return `${protocol}//${_config.serverip}:${_config.serverport}/media/${filename}?access_token=${window.token}`;
};
export const procHttpDataError = (context, data, txt) => {
  txt =
    data.error && data.error.code === HTTP_ERRORS.tokenError
      ? `${txt}, ${context.$t("langcfg.txtPleaseRelogin")}`
      : txt;
  if (window.session !== "") {
    context.message(txt, "error");
  }
};
export default httpRequest;



// WEBPACK FOOTER //
// ./src/services/httpreq/index.js